import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_126: FaireProductEntity = {
  token: "legacy_prod_abbott-126",
  type: "product",
  name: "Bell Shaped Cloche-6 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4e1e0cf9783a7e89d6784ed5229a937dbe7f3ba2f634954976223121bcc9fc65.jpeg",
  priceDollars: 32,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
